export const yourSolicitationsSteps = [
  {
    target: '#start-item',
    content: 'Esta página é destinada a exibição de Solicitações.',
    disableBeacon: true,
  },
  {
    target: '#left-filter',
    content:
      'Usando o filtro à esquerda, você pode filtrar suas solicitações por diversos critérios.',
  },
  {
    target: '#excel-report',
    content: 'Você pode extrair um relatório das solicitações exibidas.',
  },

  {
    target: '#solicitation-status',
    content: 'Aqui você pode visualizar o status de cada solicitação.',
  },
  {
    target: '#protocol-number',
    content: 'Este é o número do protocolo da solicitação.',
  },
  {
    target: '#solicitation-modal-actions',
    content: 'Aqui você pode editar anotações, anexar arquivos, ajustar datas e valores.',
  },
  {
    target: '#solicitation-modal-details',
    content: 'Todos as informacoes da solicitação estão disponíveis aqui.',
  },
  {
    target: '#solicitation-modal-content',
    content:
      'Nesta parte voce pode selecionar correspondentes para a solicitação ou abrir um chat com o correspondente selecionado.',
  },
  {
    target: '#solicitation-modal-botton-actions',
    content: 'Aqui são exibidos ações da solicitação, você pode aceitar, recusar ou cancelar.',
  },
];
